import {useItemQuery} from '@tnc/shared';
import {Link} from 'react-router';

type EntityBaseT = {
  [key: `${string}_id`]: number;
  [key: `${string}_name`]: string;
};

type ListingItemPropsT<T extends EntityBaseT> = {
  item: T;
  entityType: string;
};

function ListingItem<T extends EntityBaseT>({item, entityType}: ListingItemPropsT<T>) {
  const {data: application} = useItemQuery({
    table: 'Applications',
    id: item[`${entityType}_id`],
    idColumn: 'application_entity_id',
  });

  return (
    <div key={item[`${entityType}_id`]} className="truncate">
      <div>
        <Link to={`/${entityType}s/${item[`${entityType}_id`]}`} className="text-lg font-bold text-primary underline">
          {item[`${entityType}_name`]}
        </Link>
      </div>
      <div className="text-sm capitalize text-neutral-500">
        Edit | Delete | Status: {application?.application_status}
      </div>
    </div>
  );
}

export default ListingItem;
